import React, {useEffect, useState} from "react";
import {Table, CategoryTitle, SectionTitle} from "@housebets/housebets-x-package";
import {TLiveBetsTab, useLiveBetsData} from "./hooks/useLiveBetsData";
import {useNavigate} from "react-router-dom";
import apiGame from "app/api/game";
import {useIntl} from "react-intl";
import { useLangNavigate } from "app/hooks/useLangNavigate";

export const LiveBets: React.FC = () => {
    const {columns, data: liveBetsData, setIsHovered, tabs, setCurrentTab, setTableMaxLength, isLoading} = useLiveBetsData();
    const navigate = useNavigate();
    const {$t} = useIntl();
    const [activeClick, setActiveClick] = useState(true);
    const langNavigate = useLangNavigate();
    const [ready, setReady] = useState(false);

    useEffect(() => {
        setReady(true);
    }, []);

    return (
        <>
            <SectionTitle title={<CategoryTitle title={$t({id: "LiveBets"})} icon="LiveBets" />} marginBottom={false} />
            <React.Suspense fallback={<div>...</div>}>
                {ready ? (
                    <Table
                        emptyMessage={$t({id: "ThereIsNoData"})}
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                        liveLoad
                        handleClick={async (e) => {
                            if (activeClick && e.gameId) {
                                try {
                                    setActiveClick(false);
                                    const res = await apiGame.getGameById(Number(e.gameId));
                                    const providerName = (res.data.data.brandVo?.brandName || res.data.data.providerName || "")
                                        ?.toLowerCase()
                                        ?.replace(/ /g, "-");
                                    const gameName = (res.data.data.gameName || "")?.toLowerCase()?.replace(/ /g, "-");

                                    const gameId = res.data.data.gameId;
                                    const gameUrl = `${gameName}-${providerName}-${gameId}`;
                                    setActiveClick(true);
                                    navigate(langNavigate("/game-detail/" + gameUrl));
                                } catch (er) {
                                    setActiveClick(true);
                                }
                            }
                        }}
                        rowCountSelect
                        withShadow={!!liveBetsData.length && !isLoading}
                        noGap
                        customScrollbar={false}
                        isLoading={isLoading}
                        onTabChange={(v) => {
                            setCurrentTab(tabs[v].id as TLiveBetsTab);
                        }}
                        onCountChange={(v) => {
                            setTableMaxLength(v);
                        }}
                        column={columns}
                        data={liveBetsData}
                        tabs={{
                            buttons: tabs,
                            defaultIndex: 0,
                        }}
                        countRowNum={48}
                    />
                ) : null}
            </React.Suspense>
        </>
    );
};
